import React from 'react';

const GeneratorRegionCharges = ({ calculatedValues }) => {
    return (
        <>
            <div className='col-md-6 col-pr-20 landing-border-right'>
                <div className={`table-responsive res-cus-table ${calculatedValues && 'validated-table'}`}>
                    <table className='cus-table'>
                        <thead className='table-header'>
                            <tr>
                                <th>Applicable Charges</th>
                                <th>₹/kWh</th>
                                <th>Third Party/PPA Amount in ₹</th>
                                <th>Own Captive Amount in ₹</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>InterState POC Charges</td>
                                <td>{(calculatedValues?.applicableCharges?.interstatePocCharge[0] || 0)?.toFixed(2)}</td>
                                <td>{(calculatedValues?.applicableCharges?.interstatePocCharge[1] || 0)?.toFixed(2)}</td>
                                <td>{(calculatedValues?.applicableCharges?.interstatePocCharge[1] || 0)?.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>STU Charges - Seller</td>
                                <td>{(calculatedValues?.applicableCharges?.stuChargeSeller[0] || 0)?.toFixed(2)}</td>
                                <td>{(calculatedValues?.applicableCharges?.stuChargeSeller[1] || 0)?.toFixed(2)}</td>
                                <td>{(calculatedValues?.applicableCharges?.stuChargeSeller[1] || 0)?.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Wheeling/Distribution Charges-Seller</td>
                                <td>{(calculatedValues?.applicableCharges?.distributionChargeSeller[0] || 0)?.toFixed(2)}</td>
                                <td>{(calculatedValues?.applicableCharges?.distributionChargeSeller[1] || 0)?.toFixed(2)}</td>
                                <td>{(calculatedValues?.applicableCharges?.distributionChargeSeller[1] || 0)?.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>STU Charges - Buyer</td>
                                <td>{(calculatedValues?.applicableCharges?.stuChargeBuyer[0] || 0)?.toFixed(2)}</td>
                                <td>{(calculatedValues?.applicableCharges?.stuChargeBuyer[1] || 0)?.toFixed(2)}</td>
                                <td>{(calculatedValues?.applicableCharges?.stuChargeBuyer[1] || 0)?.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Wheeling/Distribution Charges-Buyer</td>
                                <td>{(calculatedValues?.applicableCharges?.distributionChargeBuyer[0] || 0)?.toFixed(2)}</td>
                                <td>{(calculatedValues?.applicableCharges?.distributionChargeBuyer[1] || 0)?.toFixed(2)}</td>
                                <td>{(calculatedValues?.applicableCharges?.distributionChargeBuyer[1] || 0)?.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Cross Subsidy Surcharge</td>
                                <td>{(calculatedValues?.applicableCharges?.crossSubsidySurcharge[0] || 0)?.toFixed(2)}</td>
                                <td>{(calculatedValues?.applicableCharges?.crossSubsidySurcharge[1] || 0)?.toFixed(2)}</td>
                                <td>0.00</td>
                            </tr>
                            <tr>
                                <td>Additional Surcharge</td>
                                <td>{(calculatedValues?.applicableCharges?.additionalSurcharge[0] || 0)?.toFixed(2)}</td>
                                <td>{(calculatedValues?.applicableCharges?.additionalSurcharge[1] || 0)?.toFixed(2)}</td>
                                <td>0.00</td>
                            </tr>
                            <tr>
                                <td>Other Charges</td>
                                <td>{(calculatedValues?.applicableCharges?.otherCharges[0] || 0)?.toFixed(2)}</td>
                                <td>{(calculatedValues?.applicableCharges?.otherCharges[1] || 0)?.toFixed(2)}</td>
                                <td>{(calculatedValues?.applicableCharges?.otherCharges[1] || 0)?.toFixed(2)}</td>
                            </tr>
                        </tbody>
                        <tfoot className='cus-table-ftr'>
                            <tr>
                                <td >Total Charges</td>
                                <td ></td>
                                <td >{(calculatedValues?.applicableCharges?.totalChargesThirdParty || 0)?.toFixed(2)}</td>
                                <td >{(calculatedValues?.applicableCharges?.totalChargesOwnCaptive || 0)?.toFixed(2)}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <br />
                <div className={`table-responsive res-cus-table ${calculatedValues ? 'validated-table' : ''}`}>
                    <table className='cus-table'>
                        <thead className='table-header'>
                            <tr>
                                <th>Renewal Purchase Obligation</th>
                                <th>%</th>
                                <th>Amount in ₹</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Non Solar Obligation</td>
                                <td>{(calculatedValues?.renewalPurchaseObligations?.nonSolarObligation[0] || 0)?.toFixed(2)} %</td>
                                <td>{(calculatedValues?.renewalPurchaseObligations?.nonSolarObligation[1] || 0)?.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Solar Obligation</td>
                                <td>{(calculatedValues?.renewalPurchaseObligations?.solarObligation[0] || 0)?.toFixed(2)} %</td>
                                <td>{(calculatedValues?.renewalPurchaseObligations?.solarObligation[1] || 0)?.toFixed(2)}</td>
                            </tr>

                        </tbody>
                        <tfoot className='cus-table-ftr'>
                            <tr>
                                <td>Total Obligation</td>
                                <td></td>
                                <td>{(calculatedValues?.renewalPurchaseObligations?.totalObligation || 0)?.toFixed(2)}</td>
                            </tr>

                        </tfoot>
                    </table>



                </div>

            </div>
        </>
    );
}

export default GeneratorRegionCharges;
